import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "@/components/Hero";
import BookGrid from "@/components/BookGrid";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { fetchWordPressBooks } from "@/lib/wordpress";
import { Book } from "@/types/book";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const Index = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [books, setBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBooks = async () => {
      setLoading(true);
      const fetchedBooks = await fetchWordPressBooks();
      setBooks(fetchedBooks);
      setLoading(false);
    };
    loadBooks();
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    navigate(`/library?search=${encodeURIComponent(query)}`);
  };

  // Show featured books (first 4)
  const featuredBooks = books.slice(0, 4);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Hero onSearch={handleSearch} />
      
      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 animate-fade-in">
            Featured Books
          </h2>
          <p className="text-muted-foreground animate-slide-up">
            Discover our handpicked selection of exceptional reads
          </p>
        </div>
        
        {loading ? (
          <div className="text-center py-16">
            <p className="text-muted-foreground">Loading books...</p>
          </div>
        ) : (
          <BookGrid books={featuredBooks} />
        )}
        
        <div className="text-center mt-12 animate-fade-in">
          <Button size="lg" onClick={() => navigate("/library")}>
            View All Books
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
